<template>
  <div>

    <header class="sticky">
      <div class="video-body">
        <template v-if="osName == 'android'">
          <video id="topic_video" v-show="isShowVideo && !isShowComplete" :src="video.src"
            preload="auto" width="100%" height="100%" controls @click="addView($event)"
          >
          </video>
          <a class="video-mask" v-show="!isShowVideo && !isShowComplete"  @click="playVideo(video.href)" :style="'background-image:url(' + video.poster + ')'">
            <!-- <img :src="video.poster" alt=""> -->
            <i></i>
          </a>
        </template>
        <template v-else>
          <video id="topic_video" v-show="isShowVideo" :src="video.src" preload="auto" width="100%" height="100%" controls @click="addView($event)" >
          </video>
          <a class="video-mask" v-show="!isShowVideo"  @click="playVideo(video.href)" :style="'background-image:url(' + video.poster + ')'">
            <!-- <img :src="video.poster" alt=""> -->
            <i></i>
          </a>
        </template>
        <div v-show="isShowComplete" class="video-complete-mask">
          <img class="bg" :src="video.poster" />
          <div class="cont" :class="noticeList.length ? '' : 'none-list'">
            <h5 v-if="noticeList.length">视频中提到{{ noticeList.length == 1 ? '' : '(' + noticeList.length + ')' }}</h5>
            <slider v-if="noticeList.length" :pages="pages" :sliderinit="sliderinit" :app-name="appName"></slider>
            <a class="btn-replay" @click="playVideo(video.href)" href="javascript:;"></a>
          </div>
        </div>
      </div>
      <div class="forward-app" v-show="isShowForward">
        <a v-if="isFromMiniProgram" class="forward">
          <span>去大众点评中观看，找店更方便</span>
        </a>
        <!-- <a v-else :href="video.href" class="forward"> -->
        <a v-else @click="jumpToVideo(video.href)" class="forward">
          <span>去大众点评中观看，找店更方便</span>
          <em class="arrow"></em>
        </a>
      </div>
    </header>

    <div class="video-header">
      <div class="video-info" :class="{noforward: !isShowForward}">
        <div class="video-content">
          <a v-if="!isFromMiniProgram" @click="jumpToVideo(video.href)"></a>
          <span class="video-title">{{video.title}}</span>
          <div class="video-count">
            <span>{{ video.createTime | datetime('.')}}</span>
            <span>播放次数{{video.count}}</span>
          </div>
        </div>
        <div class="author-info" v-show="isShowAuthor">
          <a v-if="isFromMiniProgram" class="forward">
            <img :src="author.imgSrc" alt="" class="avatar">
            <span class="author-name">{{author.name}}</span>
          </a>
          <a v-else :href="author.href" class="forward">
            <img :src="author.imgSrc" alt="" class="avatar">
            <span class="author-name">{{author.name}}</span>
            <span class="notice" v-show="!isShowFollow"><i></i>关注</span>
            <span class="notice nofollow" v-show="isShowFollow">已关注</span>
          </a>
        </div>
      </div>
      <template v-if="!isFromMiniProgram">
        <shopList :os-name="osName" :isShowLoading="isShowLoading" v-show="isShowNoticeList" :noticeList="noticeList" :app-name="appName"></shopList>
      </template>
      <relateVideos :videoId="videoId" :isFromMiniProgram="isFromMiniProgram"/>
      <comment v-if="showComment" :isFromMiniProgram="isFromMiniProgram" :detailHref="video.href"></comment>
    </div>
  </div>
</template>

<style lang="less">
  .video-header {
    height: 100vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    position: relative;
  }
</style>

<script>
  import shopList from './noticelist'
  import comment from './comment'
  import fecthData from '../libs/fetchData'
  import OwlPerformance from '../libs/owl-performance'
  import WhereAmI from '@dp/whereami'
  import Util from '../libs/util'
  import _ from 'lodash'
  import slider from './slide.vue'
  import getUA from '@dp/util-m-ua'
  import relateVideos from './relateVideos'
  import cookie from '@dp/cookie'

  const openapp = require('@dp/openapp')
  const KNB = require('@dp/knb')
  const latestVersion = '9.3.0'

  export default {
    name: 'video-container',
    data () {
      return {
        video: {
          src: '',
          poster: '',
          title: '',
          createTime: '',
          count: '',
          href: '',
          duration: 0
        },
        author: {
          id: '',
          name: '',
          imgSrc: '',
          href: ''
        },
        osName: '',
        isDPAPP: false,
        networkType: '',
        appName: '',
        appVersion: '',
        dpid: '',
        userId: 0,
        isShowAuthor: false,
        msg: '',
        noticeList: [],
        isShowLoading: true,
        isShowFollow: false,
        videoId: 0,
        isShowNoticeList: false,
        commentCount: 0,
        isShowForward: true,
        isShowVideo: false,
        isFirstPlay: true,
        isHasApp: true,
        isShowComplete: false,
        sliderinit: {
          currentPage: 0, //当前页码
          thresholdDistance: 100, //滑动判定距离
          thresholdTime: 1000 //滑动判定时间
        },
        currentTime: 0,  // 当前播放时间点
        intervalTimer: 0,
        toOverTime: 1000, // 毫秒
        timer: '',
        isFormSysLink: false,
        sysVVType: '',
        isFromMiniProgram: false,
        showComment: false,
        isPlayFromStart: true    // 标记视频是否从头开始播放，用于视频播放计数
      }
    },
    computed: {
      pages() {
        let arr = []
        if (this.noticeList.length) {
          arr = _.chunk(this.noticeList, 2)
        }
        return arr
      }
    },
    created () {
      let from = document.referrer;
      let vm = this;
      console.log('from: ', from);
      if (from.match(/evt.dianping.com/) && from.match(/evt.dianping.com/).length > 0) {
        let linkId = from.match(/(\d+).html/)[1];
        let cookieName = linkId + '_backup';
        console.log('cookieName: ', cookieName);
        var d = new Date();
        d.setHours(d.getHours() + 1);
        cookie(cookieName, linkId, {
          expires: d,
          path: '/',
          domain: '.dianping.com'
        })
        // document.cookie = cookieName + '=' + linkId + ';expires='+ d.toGMTString() + ';path=/;domain=.dianping.com';
        // document.cookie = cookieName + '=' + linkId;
        // document.cookie = cookieName + '=' + linkId + ';path=/;domain=.dianping.com';
        vm.sysVVType = Util.getQueryString('vvtype')
        if (location.href.indexOf('51ping') > 0) {
          vm.isFormSysLink = !!vm.sysVVType && linkId == 15953
        } else {
          vm.isFormSysLink = !!vm.sysVVType && linkId == 13433
        }
      }

      // 小程序
      let queryFromString = Util.getQueryString('from')
      this.isFromMiniProgram = queryFromString == 'miniProgram'

      this.configLocation()
      this.loadData()
      this.processVideo()
    },
    methods: {
      jumpToVideo(url) {
        cookie('13433_backup', 1, {
          expires: 0,
          path: '/',
          domain: '.dianping.com'
        })
        location.href = url;
      },
      loadData () {
        let vm = this
        vm.videoId = Util.getQueryString('videoId')
        if (vm.videoId == 0 || !vm.videoId) return
        fecthData.getdata({
          method: 'GET',
          urlname: 'getVideoInfo',
          data: {
              videoId: vm.videoId
          }
        }).then(function(data){
            let videoData = data.data
            if(videoData){
              vm.video.title = videoData.title
              vm.video.src = videoData.url
              vm.video.poster = videoData.headPic
              vm.video.createTime = new Date(videoData.publishTime).getTime()
              vm.video.duration = videoData.duration
              vm.video.count = videoData.viewCount
              vm.configShare()
              vm.getAuthorInfo(videoData.authorId)
              if (!vm.isFromMiniProgram) {
                vm.getVideoRelation(videoData.relationList)
              }
              vm.processVideo()
            }
          })

        vm.$nextTick(function () {
          // DOM is now updated
          // `this` is bound to the current instance
          let myVideo = document.getElementById('topic_video')
          myVideo.addEventListener('play',function() {
            vm.isShowVideo = true
            vm.isFirstPlay = false
            // console.log('play time', myVideo.currentTime)
            if (vm.isPlayFromStart) {
              vm.fetchVideoView()
              vm.isPlayFromStart = false
            }

            vm.timer = setInterval(function(){
              vm.currentTime = myVideo.currentTime
              // console.log('play cur time', myVideo.currentTime)
              if (vm.video.duration && myVideo.currentTime + 1 > vm.video.duration) {
                console.log('currentTime', myVideo.currentTime)
                // console.log('duration', vm.video.duration)
                vm.isShowComplete = true
                window.clearInterval(vm.timer)
              }
            }, vm.toOverTime)
          })
          myVideo.addEventListener('pause',function() {
            if(vm.isFirstPlay){
              vm.isShowVideo = false
            }else{
              vm.isShowVideo = true
              vm.isFirstPlay = false
            }
            window.clearInterval(vm.timer)
          })
          //zyh解除注释，原因是在小米手机上通过setInterval来判断视频是否播放结束这样做不准，导致视频播放完后视频中提到的商户没有展示
          myVideo.addEventListener('ended',function() {
            console.log('ended currentTime', myVideo.currentTime)
            vm.isShowComplete = true
            window.clearInterval(vm.timer)
            vm.isPlayFromStart = true
          })
          myVideo.addEventListener('durationchange', function() {
            vm.video.duration = myVideo.duration
          })
          vm.processVideo()
          vm.judgeVideoHref()

          // owl 性能上报
          OwlPerformance()
        })
      },
      videoCompleted () {
        this.isShowComplete
      },
      judgeVideoHref () {
        let vm = this
        vm.video.href = fecthData.getHref('detailHref', vm.videoId)

        KNB.ready(function(){
          KNB.getNetworkType({
            success: function(ret){
              vm.networkType = ret.networkType //'2g','3g','4g','wifi',undefined
              console.log(vm.networkType)
            }
          })

          KNB.getUserInfo({
            success: function(user){
              vm.dpid = user.uuid,
              vm.userId = user.userId
            }
          })

          KNB.getUA({
            success: function(info){
              vm.osName = info.osName
              vm.appName = info.appName
              vm.appVersion = info.appVersion
              console.log('knb', info.osName, info.appName, info.appVersion)
              vm.isDPAPP = false
              let isNewVersion = false
              if(info && info.appName == 'dianping'){
                vm.isDPAPP = true
                isNewVersion = KNB.Semver.gte(info.appVersion, latestVersion)
              }
              if(vm.isDPAPP){
                vm.isShowForward = false
                let _video = document.getElementById('topic_video');
                if (_video && _video.src) {
                  let netWork = Util.getNetwork()
                  if(netWork  == 'wifi'){
                    $('video').attr('autoplay', 'autoplay')
                  }
                }
              }
              if(vm.isDPAPP&&!isNewVersion){
                vm.video.href = fecthData.getHref('H5VideoHref', vm.videoId)
              }
            }
          })
        })
      },
      mounted(){
        this.processVideo()
        this.judgeVideoHref()
      },
      configLocation(){
        WhereAmI.config({
          timeout: 10000,
          enables: [],
          disables: [],
          urlParamNames: [],
          cacheType: "cookie",
          cookieNames: ["locallat", "locallng"],
          storageName: "whereami",
          wxAutoConfig: false,
          city: false,
          cityType: 'dianping',
          source: '',
          sampling: 0.5,
          debug: false
        });
      },
      getAuthorInfo (authorId) {
          let vm =  this
          fecthData.getdata({
            method: 'GET',
            urlname: 'getAuthorInfo',
            data: {
              authorId: authorId
            }
          }).then(function(data){
              let authorData = data.data && data.data.authorInfo
              if(authorData){
                vm.isShowAuthor = true
                vm.author = {
                  id: authorData.userID,
                  name: authorData.name,
                  imgSrc: authorData.headPic,
                  href: fecthData.getHref('authorHref',authorId) + '&anchorvideotap=1'
                }
                vm.isShowFollow = authorData.isFollow
              }
          })
      },
      getVideoRelation(relationList){
        let vm =  this
        let _location
        WhereAmI(function(res){
          _location = res
          fecthData.getdata({
            method: 'post',
            data: {
              lat: _location.lat,
              lng: _location.lng,
              videoId: vm.videoId,
              utmSource: vm.isDPAPP ? 'video_dianping' : 'video_union',
              relationList: relationList
            },
            urlname: 'getNoticeList'
          }).then(function(data){
            vm.isShowLoading = false
            vm.noticeList = data.data[vm.videoId]

            if(vm.noticeList && vm.noticeList.length > 0) {
              vm.isShowNoticeList = true

              vm.noticeList.map((item) => {
                item.starClass = 'star-' + item.star
                item.typeClass = 'item-' + item.showType
                if (item.showType === 3) {   //美食SKU
                  // item.price = item.labelFirst
                  if(item.star === 0){
                    item.starClass = 'star-no'
                  }

                  item.href = vm.isDPAPP ? item.jumpUrl : fecthData.getHref('dishSkuHref',item.objectId)
                  if (item.objectType == 7) {
                    if (item.jumpUrl.indexOf('dianping://web?url=') == 0) {
                      let h5Href = decodeURIComponent(item.jumpUrl.replace('dianping://web?url=', ''));
                      // 加综合链接
                      if (h5Href.indexOf('?') == -1) {
                        h5Href += '?'
                      }
                      item.href = vm.isDPAPP ? item.jumpUrl : 'https://evt.dianping.com/synthesislink/17412.html?url=' + encodeURIComponent(h5Href);
                    } else if (item.jumpUrl.indexOf('dianping://user?userid=') == 0) {
                      let userId = item.jumpUrl.replace('dianping://user?userid=', '');
                      item.href = vm.isDPAPP ? item.jumpUrl : fecthData.getHref('authorHref', userId)
                    }
                  } else if(item.objectType == 8 || item.objectType == 9 || item.objectType == 10 || item.objectType == 11){
                      let url = ''
                      if(vm.isDPAPP){
                          url = item.jumpUrl.match(/^dianping:\/\/web\?url=(.*)/)[1]
                          url = window.decodeURIComponent(url)
                          url = url.indexOf('?')>-1 ? url + '&utm_source=sp' : url + '?utm_source=sp'
                          url = 'dianping://web?url=' + window.encodeURIComponent(url)
                      } else{
                          url = item.webJumpUrl
                          url = url.indexOf('?')>-1 ? url + '&utm_source=sp' : url + '?utm_source=sp'
                      }
                      item.href = url
                  }
                } else if (item.showType === 4) { //美妆SKU
                  item.starClass = 'star-' + parseInt(item.star) * 5
                  item.href = vm.isDPAPP ? item.jumpUrl : fecthData.getHref('beautySkuHref',item.objectId)
                } else if (item.showType === 2 || item.showType === 5) {  //技师（休娱，美妆
                  // if(item.star === 0){
                  //   item.starClass = 'star-no'
                  // }
                  // item.price = item.labelFirst
                  if(item.objectType === 4){  //休闲娱乐技师
                     item.href = vm.isDPAPP ? item.jumpUrl : fecthData.getHref('joyTechHref',item.objectId)
                  }else if(item.objectType === 6){  //教师
                    if(item.star === 0){
                      item.starClass = 'star-no'
                    }
                    item.href = vm.isDPAPP ? item.jumpUrl : fecthData.getHref('teacherHref',item.objectId)
                  }else if(item.objectType === 5){  //美妆技师
                     item.href = vm.isDPAPP ? item.jumpUrl : fecthData.getHref('beautyTechHref',item.objectId)
                  } else if (item.objectType === 12) { // 电影
                    item.href = vm.isDPAPP ? item.jumpUrl : fecthData.getHref('movieHref',item.objectId)
                  }
                }else if(item.objectType === 1){  //shop
                  if (vm.isDPAPP) {
                    item.href = item.jumpUrl
                  } else {
                    item.href = fecthData.getHref('shopHref',item.objectId) + '&utm=' + encodeURIComponent('utm_source:video_union,utm_medium:' + vm.videoId)
                  }
                }
              })
            }else{
                vm.noticeList = []
            }
          })
        }, function(){
            fecthData.getdata({
              method: 'post',
              data: {
                lat: 0,
                lng: 0,
                videoId: vm.videoId,
                utmSource: vm.isDPAPP ? 'video_dianping' : 'video_union',
                relationList: relationList
              },
              urlname: 'getNoticeList'
            }).then(function(data) {
              vm.isShowLoading = false
              vm.noticeList = data.data[vm.videoId]
              if(vm.noticeList && vm.noticeList.length > 0){
                vm.isShowNoticeList = true
                // vm.noticeList.map((item) => {
                //   item.starClass = 'star-' + item.star
                //   item.typeClass = 'item-' + item.showType
                //   if (item.showType === 3) {   //美食SKU
                //     // item.price = item.labelFirst
                //   } else if (item.showType === 4) { //美妆SKU
                //     item.starClass = 'star-' + parseInt(item.star) * 5
                //   } else if (item.showType === 2) {  //技师（休娱，美妆）
                //     // item.labelSecond = item.labelFirst
                //   } else if(item.objectType === 1){  //shop
                //     // item.href = fecthData.getHref('shopHref',item.objectId)
                //     if (vm.isDPAPP) {
                //       item.href = item.jumpUrl
                //     } else {
                //       item.href = fecthData.getHref('shopHref',item.objectId) + '&utm=' + encodeURIComponent('utm_source:video_union,utm_medium:' + vm.videoId)
                //     }
                //   }
                // })
                vm.noticeList.map((item) => {
                  item.starClass = 'star-' + item.star
                  item.typeClass = 'item-' + item.showType

                  if (item.showType === 3) {   //美食SKU
                    if(item.star === 0){
                      item.starClass = 'star-no'
                    }
                    item.href = vm.isDPAPP ? item.jumpUrl : fecthData.getHref('dishSkuHref',item.objectId)
                    if (item.objectType == 7) {
                      if (item.jumpUrl.indexOf('dianping://web?url=') == 0) {
                        let h5Href = decodeURIComponent(item.jumpUrl.replace('dianping://web?url=', ''));
                        // 加综合链接
                        if (h5Href.indexOf('?') == -1) {
                          h5Href += '?'
                        }
                        item.href = vm.isDPAPP ? item.jumpUrl : 'https://evt.dianping.com/synthesislink/17412.html?url=' + encodeURIComponent(h5Href);
                      } else if (item.jumpUrl.indexOf('dianping://user?userid=') == 0) {
                        let userId = item.jumpUrl.replace('dianping://user?userid=', '');
                        item.href = vm.isDPAPP ? item.jumpUrl : fecthData.getHref('authorHref', userId)
                      }
                      // item.href = vm.isDPAPP ? item.jumpUrl : fecthData.getHref('authorHref',item.objectId)
                    } else if(item.objectType == 8 || item.objectType == 9 || item.objectType == 10 || item.objectType == 11){
                      let url = ''
                      if(vm.isDPAPP){
                          url = item.jumpUrl.match(/^dianping:\/\/web\?url=(.*)/)[1]
                          url = window.decodeURIComponent(url)
                          url = url.indexOf('?')>-1 ? url + '&utm_source=sp' : url + '?utm_source=sp'
                          url = 'dianping://web?url=' + window.encodeURIComponent(url)
                      } else{
                          url = item.webJumpUrl
                          url = url.indexOf('?')>-1 ? url + '&utm_source=sp' : url + '?utm_source=sp'
                      }
                      item.href = url
                    }
                  } else if (item.showType === 4) { //美妆SKU
                    item.starClass = 'star-' + parseInt(item.star) * 5
                    item.href = vm.isDPAPP ? item.jumpUrl : fecthData.getHref('beautySkuHref',item.objectId)
                  } else if (item.showType === 2 || item.showType === 5) {  //技师（休娱，美妆
                    if(item.objectType === 4){  //休闲娱乐技师
                      item.href = vm.isDPAPP ? item.jumpUrl : fecthData.getHref('joyTechHref',item.objectId)
                    }else if(item.objectType === 6){  //教师
                      if(item.star === 0){
                        item.starClass = 'star-no'
                      }
                      item.href = vm.isDPAPP ? item.jumpUrl : fecthData.getHref('teacherHref',item.objectId)
                    }else if(item.objectType === 5){  //美妆技师
                      item.href = vm.isDPAPP ? item.jumpUrl : fecthData.getHref('beautyTechHref',item.objectId)
                    } else if (item.objectType === 12) { // 电影
                      item.href = vm.isDPAPP ? item.jumpUrl : fecthData.getHref('movieHref',item.objectId)
                    }
                  }else if(item.objectType === 1){  //shop
                    if (vm.isDPAPP) {
                      item.href = item.jumpUrl
                    } else {
                      item.href = fecthData.getHref('shopHref',item.objectId) + '&utm=' + encodeURIComponent('utm_source:video_union,utm_medium:' + vm.videoId)
                    }
                  }
                })
              }else{
                vm.noticeList = []
              }
            })
        });

      },
      processVideo () {
        //处理视频不全屏播放
        let vm = this
        let $ = require('jquery')
        //android inline play
//        $('video').attr('x5-video-player-type', 'h5');
//        $('video').attr('x5-video-player-fullscreen', 'true');
//        $('video').attr('x-webkit-airplay', 'allow');

        //IOS forbid full-screen  x5­-video­-player­-fullscreen
        $('video').attr('playsinline', 'true');
        $('video').attr('webkit-playsinline', 'true')

        let _video = document.getElementById('topic_video');
        if (_video && _video.src) {
          let netWork = Util.getNetwork()
          if(netWork  == 'wifi'){
            $('video').attr('autoplay', 'autoplay')
          }
        }
        if(window.location.href.indexOf('enablevideo') > 0) {
            let $ = require('jquery')
            let video = $('video')
            video[0].play()
        }
      },
      addView (e) {
        let vm = this
        let video = e.target
        let isPlaying = video.currentTime > 0 && !video.paused && !video.ended
          && video.readyState > 2;

        console.log('currentTime', video.currentTime);
        if (!isPlaying) {
          vm.isShowVideo = true
          video.play();
        } else {
          video.pause();
        }
      },
      fetchVideoView (){
        // count video play
        let vm = this
        // fecthData.getdata({
        //   urlname: 'addView',
        //   data: {
        //     videoId: vm.videoId
        //   }
        // })

        let valLab = {
          "custom": {
            "video_id": vm.videoId
          }
        };
        LXAnalytics && LXAnalytics('moduleClick', 'b_ygo8ghfu', valLab);
        LXAnalytics && LXAnalytics('moduleClick', 'b_xgmayyzi', {
          'custom': {
            'biz_id': vm.videoId
          }
        })

        let lxsdk_cuid = cookie('_lxsdk_cuid') || '';

        // 增加owl统计
        if (!lxsdk_cuid) {
          Owl.addError({
            name: 'play count',
            msg: `netType='${vm.networkType}' userId='${vm.userId}' dpId='${vm.isDPAPP ? vm.dpid : lxsdk_cuid}' source='${vm.isFormSysLink ? vm.sysVVType : (vm.isDPAPP ? 'internal_h5' : 'shareto_h5')}' platform='${vm.osName}' version='${vm.appVersion}' appType='${vm.isDPAPP ? 'MainAPP' : 'H5'}'`
          },{
            combo: false,
            level: 'info',
            category: 'jsError',
            tags: {
              videoId: vm.videoId,
              page: 'index'
            }
          })
        }

        fecthData.getdata({
          method: 'post',
          urlname: 'addView',
          data: {
            videoId: vm.videoId,
            netType: vm.networkType,
            userId: vm.userId,
            dpId: vm.isDPAPP ? vm.dpid : lxsdk_cuid,
            source: vm.isFormSysLink ? vm.sysVVType : (vm.isDPAPP ? 'internal_h5' : 'shareto_h5'),
            platform: vm.osName,
            version: vm.appVersion,
            appType: vm.isDPAPP ? 'MainAPP' : 'H5'
          }
        })
      },
      configShare () {
          let vm = this
          let Share = require('@dp/util-m-share');
          return new Share({
            title: vm.video.title,
            desc: '【大众点评视频，吃货都在看】',
            url: window.location.href,
            image: vm.video.poster + '@200w_200h_1e_1c',
            content: '「点评视频」' + vm.video.title,
            channelDPApp: [Share.CHANNEL.WECHAT_FRIENDS,Share.CHANNEL.WECHAT_TIMELINE],
            channelWX: [Share.CHANNEL.WECHAT_FRIENDS,Share.CHANNEL.WECHAT_TIMELINE],
            channelBrowser: [Share.CHANNEL.WEIBO,Share.CHANNEL.WEIBO_TECENT],
            channelQQ: [Share.CHANNEL.WECHAT_FRIENDS],
            handle: function(){},
              success: function(){console.log('share success');},
              fail: function(){console.log('share failed');},
              cancel: function(){console.log('share canceled');}
            },{
            hide: false
          })
      },
      playVideo (href) {
        let vm = this
      	// if(window.location.href.indexOf('enablevideo') == -1){
        //   window.location.href = href
          // let vm = this
          // let url = 'dianping://shortvideodetail?isreview=0&videoid=' + vm.videoId
          // console.log(url)
          // openapp('dianping://shortvideodetail?isreview=0&videoid=' + vm.videoId, {
          //   onFail: function(type) {
          //     vm.isHasApp = false
          //     let $ = require('jquery')
          //     let video = $('video')
          //     setTimeout(function(){
          //       video[0].play()
          //       vm.isShowVideo = true
          //       vm.isShowComplete = false
          //     }, 500);
          //   }
          // })
        // } else {
      		// vm.isHasApp = false
          let $ = require('jquery')
          let video = $('video')
          video[0].play()
          vm.isShowVideo = true
          vm.isShowComplete = false
        // }
      }
    },
    components: {
      shopList,
      comment,
      slider,
      relateVideos
    }
  }
</script>



// WEBPACK FOOTER //
// videoPlayer.vue?f46ead84